import { createFileRoute } from '@tanstack/react-router'
import ClubsView from "../../../../players/ClubsView.tsx";

export const Route = createFileRoute('/_app/clubs/$club_uid/edit')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ClubsView />
}
